//@flow
import Constants from '../constants';
import Dispatcher from '../dispatcher';
import APIInterface from '../APIInterfaces/membership';

export default {
  setNewMemberPlan(code:string) {
    Dispatcher.dispatchAction(Constants.SET_NEW_MEMBER_PLAN, { code });
  },

  // createMembership can be used to set
  // a free membership plan for a user
  // WITHOUT requiring they complete a checkout first
  createMembership(code:string) {
    APIInterface.createMembership({plan_code: code});
  },

  cancelMembership(membershipId:string) {
    APIInterface.cancelMembership(membershipId);
  },
};
